export const EXCMDEVICEPERIPHERALDEVICE_CREATE_RESET = 'EXCMDEVICEPERIPHERALDEVICE_CREATE_RESET'
export const EXCMDEVICEPERIPHERALDEVICE_CREATE_SET_CREATED = 'EXCMDEVICEPERIPHERALDEVICE_CREATE_SET_CREATED'
export const EXCMDEVICEPERIPHERALDEVICE_CREATE_SET_ERROR = 'EXCMDEVICEPERIPHERALDEVICE_CREATE_SET_ERROR'
export const EXCMDEVICEPERIPHERALDEVICE_CREATE_SET_VIOLATIONS = 'EXCMDEVICEPERIPHERALDEVICE_CREATE_SET_VIOLATIONS'
export const EXCMDEVICEPERIPHERALDEVICE_CREATE_TOGGLE_LOADING = 'EXCMDEVICEPERIPHERALDEVICE_CREATE_TOGGLE_LOADING'
